/**
 * TenantMapPage — SAAS-TENANT-PORTAL-MAP-1.
 *
 * Página "Mapa" do portal do cliente (tenant_owner/tenant_admin/viewer). Mostra
 * os dispositivos do PRÓPRIO tenant no mapa. Reaproveita o DeviceMapPanel SEM
 * `tenantId` → o backend escopa por ctx.tenant_id (o request não manda tenant_id;
 * nunca X-Tenant), então cada tenant só vê a própria frota. super_admin, que
 * também enxerga este item, vê a frota global (mesma semântica de Dispositivos).
 */
import DeviceMapPanel from "../components/tenants/DeviceMapPanel.jsx";

export default function TenantMapPage({ onNavigate }) {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Mapa dos dispositivos</h1>
        <p className="text-xs text-noc-muted">
          Localização e status dos equipamentos da sua empresa.
        </p>
      </div>
      <DeviceMapPanel onNavigate={onNavigate} />
    </div>
  );
}
